import { ReactNode } from 'react';

import { TRowStyleProps } from '@/shared/components/ui/shared-styles/shared-styles.types';
import { TPermissionCheck } from '@/shared/features/permissions/permission-check.types';

export enum TFeatureCardVariant {
  DEFAULT = 'default',
  SMALL = 'small',
}

export type TFeatureCardProps = {
  icon?: ReactNode;
  title: string;
  titleAdornment?: ReactNode;
  description?: ReactNode;
  navigateTo?: string;
  variant?: TFeatureCardVariant;
  visible?: boolean;
  permission?: TPermissionCheck;
};

export type TFeatureCardContainerProps = TRowStyleProps & {
  $variant?: TFeatureCardVariant;
};
